import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import { genericGridAccessor } from 'ps-components/AdvancedTable/GenericGrid/GenericGridFunctions';
import { PricingDetails, PricingDetailsSubRow } from './JobPricingCellRender';
import React, { Fragment } from 'react';
import Input from 'ps-components/Input/Input';
import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';
import ReactTooltip from 'react-tooltip';
import { PRICING_TYPE } from '../../../SkillGeoDifferential/SkillGeoDifferentialReducer';
import GG_DEFAULTS from '../../../../lib/genericGridDefaults';

const PRICING_DETAILS_EDITING_ADJUSTMENT = 'PRICING_DETAILS_EDITING_ADJUSTMENT';
const PRICING_DETAILS_EDITING_ADJUSTMENT_CANCEL = 'PRICING_DETAILS_EDITING_ADJUSTMENT_CANCEL';
const PRICING_DETAILS_EDITING_OVERALL_ADJUSTMENT = 'PRICING_DETAILS_EDITING_OVERALL_ADJUSTMENT';
const PRICING_DETAILS_EDITING_OVERALL_ADJUSTMENT_CANCEL = 'PRICING_DETAILS_EDITING_OVERALL_ADJUSTMENT_CANCEL';
const PRICING_DETAILS_EDITING_COMMENT = 'PRICING_DETAILS_EDITING_COMMENT';
const PRICING_DETAILS_EDITING_COMMENT_CANCEL = 'PRICING_DETAILS_EDITING_COMMENT_CANCEL';
const PRICING_DETAILS_EDITING_OVERALL_COMMENT = 'PRICING_DETAILS_EDITING_OVERALL_COMMENT';
const PRICING_DETAILS_EDITING_OVERALL_COMMENT_CANCEL = 'PRICING_DETAILS_EDITING_OVERALL_COMMENT_CANCEL';
const PRICING_DETAILS_EDITING_CANCEL = 'PRICING_DETAILS_EDITING_CANCEL';
const PRICING_DETAILS_CHECKING_PARTICIPATION = 'PRICING_DETAILS_CHECKING_PARTICIPATION';
const PRICING_DETAILS_UNCHECKING_PARTICIPATION = 'PRICING_DETAILS_UNCHECKING_PARTICIPATION';
const PRICING_DETAILS_PARTICIPATION_SUCCESS = 'PRICING_DETAILS_PARTICIPATION_SUCCESS';
const PRICING_DETAILS_PARTICIPATION_ERROR = 'PRICING_DETAILS_PARTIPCATION_ERROR';
const PRICING_DETAILS_RESET = 'PRICING_DETAILS_RESET';

const PRICING_DETAILS_SLOTTED_DETAILS_START = 'PRICING_DETAILS_SLOTTED_DETAILS_START';
const PRICING_DETAILS_SLOTTED_DETAILS_SUCCESS = 'PRICING_DETAILS_SLOTTED_DETAILS_SUCCESS';
const PRICING_DETAILS_SLOTTED_DETAILS_ERROR = 'PRICING_DETAILS_SLOTTED_DETAILS_ERROR';
const PRICING_DETAILS_SLOTTED_EXPANDED_TOGGLE = 'PRICING_DETAILS_SLOTTED_EXPANDED_TOGGLE';
const PRICING_DETAILS_SLOTTED_DETAILS_RESET = 'PRICING_DETAILS_SLOTTED_DETAILS_RESET';

const FIXED_DECIMAL = 3;

export const FOCUS = {
  ADJ: 'focus-adj',
  GEO: 'focus-geo',
  WGT: 'focus-wgt'
};

export const HIDDEN_TERMS = [
  'field_survey_year',
  'field_org_job_code',
  'field_org_job_code_key',
  'field_org_job_title',
  'field_survey_code',
  'field_job_code',
  'field_job_scope',
  'field_total_companies',
  'field_total_incumbents',
  'field_cut_id',
  'field_currency',
  'field_pub_survey_short_name',
  'field_pub_survey_long_name',
  'field_pub_survey_effective_date',
  'field_aging_code',
  'field_last_mod_user_name',
  'field_benchmark_comment',
  'field_last_modified',
  'field_aging_date',
  'field_job_title',
  'formula_match_id',
  'field_job_description',
  'field_data_weighting_factor',
  'field_aging_factor',
  'field_geo_adj_factor',
  'field_data_adjustment_factor',
  'field_data_adjustment_factor_reason',
  'field_participation_p',
  'field_match_id',
  'field_benchmark_adjustment',
  'field_slot_job_code',
  'field_slot_job_code_key',
  'org_job_id_default',
  'org_job_code_default',
  'org_job_code_key_default',
  'org_job_description_default',
  'participation_p_default',
  'formula_total_paid_cash_amt',
  'formula_base_salary'
];

const SaveText = () => {
  return (
    <div className="pricing-details__save-instruction">
      <div>
        <span className="bold">Enter</span> <span className="text"> save</span>
      </div>
      <div>
        <span className="bold">Esc</span> <span className="text"> cancel</span>
      </div>
    </div>
  );
};
export const ModifyAging = (rowData, key, options) => {
  if (options.isSummary || options.isMarketComparison) {
    return <div />;
  }

  const aging = rowData.aging_factor_default;
  const modifyValue = Number.isInteger() ? aging : aging?.toFixed(FIXED_DECIMAL);

  return <div>{modifyValue || ''}</div>;
};

function onClickAdjustment(focus, rowData, options) {
  options.clearModifiedStates();
  options.setFocusedInput(focus);
  options.jobPricingGridActions.startEditingAdjustment(
    rowData.match_id_default,
    options.commentMatchId || options.adjustmentMatchId,
    options.saveMatch,
    options.editingOverallComment || options.editingOverallAdjustment,
    options.saveOverall
  );
}

export const ModifyAdj = (rowData, key, options) => {
  if (options.isSummary || options.isMarketComparison) {
    return <div />;
  }
  const adj = rowData.data_adjustment_factor_default;
  const modifyValue = Number.isInteger(adj) ? adj : adj?.toFixed(FIXED_DECIMAL);

  if (options.readOnly || options.meta.isSubRow) {
    return modifyValue || '0';
  }

  if (options.adjustmentMatchId && options.adjustmentMatchId === rowData.match_id_default) {
    return (
      <React.Fragment>
        <Input
          id={FOCUS.ADJ}
          passedRef={options.focusedInput === FOCUS.ADJ && options.currentFocusRef}
          type="float"
          step="0.001"
          defaultValue={adj}
          onChange={options.onAdjChange}
          className="pricing-details-adjustment__input"
          onKeyUp={options.handleKeyUpOnJob}
          onBlur={options.handleOnBlur}
        />
        {SaveText()}
      </React.Fragment>
    );
  }

  return <a onMouseDown={() => onClickAdjustment(FOCUS.ADJ, rowData, options)}>{modifyValue || '0'}</a>;
};

export const ModifyGeo = (rowData, key, options) => {
  if (options.isSummary || options.isMarketComparison) {
    return <div />;
  }

  const geo = rowData.geo_adj_factor_default;
  const modifyValue = Number.isInteger(geo) ? geo : geo?.toFixed(FIXED_DECIMAL);

  if (options.readOnly || options.meta.isSubRow) {
    return modifyValue || '0';
  }

  if (options.adjustmentMatchId && options.adjustmentMatchId === rowData.match_id_default) {
    return (
      <React.Fragment>
        <Input
          id={FOCUS.GEO}
          passedRef={options.focusedInput === FOCUS.GEO && options.currentFocusRef}
          type="float"
          step="0.01"
          defaultValue={geo}
          onChange={options.onGeoChange}
          className="pricing-details-adjustment__input"
          onKeyUp={options.handleKeyUpOnJob}
          onBlur={options.handleOnBlur}
        />
      </React.Fragment>
    );
  }

  return <a onMouseDown={() => onClickAdjustment(FOCUS.GEO, rowData, options)}>{modifyValue || '0'}</a>;
};

export const ModifyWgt = (rowData, key, options) => {
  const isSlotted = options?.pricingType === PRICING_TYPE.SLOTTED;
  const matchId = rowData.match_id_default;
  const weightId = `weight-${matchId}`;
  const weight = rowData.data_weighting_factor_default;

  if (options.isSummary || options.isMarketComparison) {
    return <div />;
  }

  const modifyValue = Number.isInteger(weight) ? weight : weight?.toFixed(FIXED_DECIMAL);

  let weightText = 'Custom Weighting';
  if (!isSlotted) {
    const weightValue = Number(modifyValue);
    const companies = rowData.total_companies_default;
    const employees = rowData.total_incumbents_default;

    if (weightValue === companies) {
      weightText = 'Weighted by Companies';
    } else if (weightValue === employees) {
      weightText = 'Weighted by Employees';
    } else if (weightValue === 0) {
      weightText = 'Zero Weighted';
    } else if (weightValue === 1) {
      weightText = 'Equal Weighting';
    }
  }

  if (options.readOnly || options.meta.isSubRow) {
    return modifyValue || '0';
  }

  if (options.adjustmentMatchId && options.adjustmentMatchId === rowData.match_id_default) {
    return (
      <React.Fragment>
        <Input
          id={FOCUS.WGT}
          passedRef={options.focusedInput === FOCUS.WGT && options.currentFocusRef}
          type="float"
          step="0.01"
          defaultValue={rowData.data_weighting_factor_default}
          onChange={options.onWgtChange}
          className="pricing-details-adjustment__input"
          onKeyUp={options.handleKeyUpOnJob}
          onBlur={options.handleOnBlur}
        />
      </React.Fragment>
    );
  }

  if (isSlotted) {
    return <a onMouseDown={() => onClickAdjustment(FOCUS.WGT, rowData, options)}>{modifyValue || '0'}</a>;
  }

  return (
    <Fragment>
      <a onMouseDown={() => onClickAdjustment(FOCUS.WGT, rowData, options)} data-tip={weightText} data-for={weightId}>
        {modifyValue || '0'}
      </a>

      <ReactTooltip id={weightId} place="bottom" />
    </Fragment>
  );
};

const DeleteColumn = (rowData, key, options) => {
  if (options.isSummary || options.readOnly || options.meta.isSubRow || options.isMarketComparison) {
    return <div />;
  }

  return (
    <div className="pricing-details__delete">
      <i
        onMouseDown={() => {
          options.onDelete(rowData.match_id_default);
        }}
        className="icon-trash"
      />
    </div>
  );
};

const newGenericGrid = new GenericGridCreator(
  'PRICING_PAGE',
  {},
  {
    surveysForSlottedMatches: {},
    slottedDetailsLoading: [],
    slottedExpandedSections: {},
    uncheckingParticipationIDs: [],
    checkingParticipationIDs: [],
    selectedCutIDs: [],
    defaultLeftColumns: [
      {
        Header: '',
        stickyLeft: true,
        id: 'delete-match',
        customRender: (rowData, key, options) => {
          if (options.meta.isSubRow) {
            return <div />;
          }

          return DeleteColumn(rowData, key, options);
        },
        width: 30,
        centerAlign: true,
        accessor: null,
        minWidth: 30,
        maxWidth: 30,
        getClassName: options => {
          return options.meta.isSubRow ? 'sub-row-delete' : '';
        }
      },
      {
        Header: data => {
          return data.options.pricingType === PRICING_TYPE.SLOTTED ? 'Slotted Job Match' : 'Survey Job Match';
        },
        id: 'match',
        stickyLeft: true,
        customRender: (rowData, key, options) => {
          if (options.meta.isSubRow) {
            return PricingDetailsSubRow(rowData, key, options);
          }

          return PricingDetails(rowData, key, options);
        },
        width: 350,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'job_title'),
        centerAlign: false,
        leftAlign: true,
        onTop: 2,
        minWidth: 350,
        maxWidth: 350,
        getClassName: options => {
          return options.meta.isSubRow ? 'sub-row-custom-render' : '';
        }
      },
      {
        Header: 'Aging',
        id: 'aging-column',
        stickyLeft: true,
        customRender: ModifyAging,
        width: 70,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'aging_factor'),
        centerAlign: true,
        maxWidth: 70
      },
      {
        Header: 'Adj',
        id: 'adj-column',
        stickyLeft: true,
        customRender: ModifyAdj,
        width: 70,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'data_adjustment_factor'),
        centerAlign: true,
        onTop: 1,
        maxWidth: 70
      },
      {
        Header: 'Geo',
        id: 'geo-column',
        stickyLeft: true,
        customRender: ModifyGeo,
        width: 70,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'geo_adj_factor'),
        centerAlign: true,
        maxWidth: 70
      },
      {
        Header: 'Wgt',
        id: 'wgt-column',
        stickyLeft: true,
        customRender: ModifyWgt,
        width: 70,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'data_weighting_factor'),
        centerAlign: true,
        maxWidth: 70
      }
    ],
    hiddenTerms: HIDDEN_TERMS
  },
  {
    getInstanceState: store => store.marketPricing.JobPricingReducer.JobPricingGridReducer
  }
);
export const jobPricingGridActions = newGenericGrid.getActions();

jobPricingGridActions.startEditingAdjustment = (matchId, prevMatchId, saveMatch, editingOverallPrev, saveOverall) => {
  if (prevMatchId) saveMatch(false);
  if (editingOverallPrev) saveOverall(false);
  return {
    type: PRICING_DETAILS_EDITING_ADJUSTMENT,
    currentAdjustmentEditMatch: matchId
  };
};

jobPricingGridActions.cancelEditingAdjustment = () => {
  return {
    type: PRICING_DETAILS_EDITING_ADJUSTMENT_CANCEL
  };
};

jobPricingGridActions.startEditingComment = (matchId, prevMatchId, saveMatch, editingOverallPrev, saveOverall) => {
  if (prevMatchId) saveMatch(false);
  if (editingOverallPrev) saveOverall(false);
  return {
    type: PRICING_DETAILS_EDITING_COMMENT,
    currentCommentEditMatch: matchId
  };
};

jobPricingGridActions.cancelEditingComment = () => {
  return {
    type: PRICING_DETAILS_EDITING_COMMENT_CANCEL
  };
};

jobPricingGridActions.cancelEditingAll = () => {
  return {
    type: PRICING_DETAILS_EDITING_CANCEL
  };
};

jobPricingGridActions.startEditingOverallAdjustment = (prevMatchId, saveMatch, editingOverallPrev, saveOverall) => {
  if (prevMatchId) saveMatch(false);
  if (editingOverallPrev) saveOverall(false);
  return {
    type: PRICING_DETAILS_EDITING_OVERALL_ADJUSTMENT
  };
};

jobPricingGridActions.cancelEditingOverallAdjustment = () => {
  return {
    type: PRICING_DETAILS_EDITING_OVERALL_ADJUSTMENT_CANCEL
  };
};

jobPricingGridActions.startEditingOverallComment = (prevMatchId, saveMatch, editingOverallPrev, saveOverall) => {
  if (prevMatchId) saveMatch(false);
  if (editingOverallPrev) saveOverall(false);
  return {
    type: PRICING_DETAILS_EDITING_OVERALL_COMMENT
  };
};

jobPricingGridActions.cancelEditingOverallComment = () => {
  return {
    type: PRICING_DETAILS_EDITING_OVERALL_COMMENT_CANCEL
  };
};

jobPricingGridActions.resetJobPricingGrid = () => {
  return {
    type: PRICING_DETAILS_RESET
  };
};

jobPricingGridActions.checkParticipation = (orgJobId, matchId, check, benchmarkYear, editPastYears) => {
  return async dispatch => {
    const errorMessage = `Failed to update (${check ? 'check' : 'uncheck'}) participation`;

    dispatch({
      type: check ? PRICING_DETAILS_CHECKING_PARTICIPATION : PRICING_DETAILS_UNCHECKING_PARTICIPATION,
      matchId
    });
    try {
      const results = await apiClient.apiPut('/api/market-pricing/job-matches/updateMatches', {
        org_job_id: orgJobId,
        matches: [{ matchId: matchId, participation: check }],
        benchmarkYear,
        editPastYears
      });
      if (results.data.success) {
        dispatch({ type: PRICING_DETAILS_PARTICIPATION_SUCCESS, matchId });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      console.error(error);
      addAlert(errorMessage, 'danger');
      dispatch({ type: PRICING_DETAILS_PARTICIPATION_ERROR });
    }
  };
};

jobPricingGridActions.resetSubRows = () => {
  return async dispatch => {
    dispatch({ type: PRICING_DETAILS_SLOTTED_DETAILS_RESET });
  };
};

jobPricingGridActions.getSurveysForSlotted = (
  job,
  benchmarkYear,
  displayIn,
  masterAccountId,
  currency,
  expanded = true,
  viewName
) => {
  return async dispatch => {
    const errorMessage = `Error retrieving survey matches for ${job.title}`;

    try {
      dispatch({ type: PRICING_DETAILS_SLOTTED_DETAILS_START, id: job.id });
      const options = {
        benchmarkYear,
        jobCode: job.code,
        jobCodeKey: job.codeKey,
        displayIn: displayIn.toLowerCase(),
        currency,
        viewName,
        isSlotted: false
      };
      const result = await await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/org-jobs/pricing`, options);

      if (result?.status === 200) {
        dispatch({ type: PRICING_DETAILS_SLOTTED_DETAILS_SUCCESS, id: job.id, data: result, expanded });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log(error);
      dispatch({ type: PRICING_DETAILS_SLOTTED_DETAILS_ERROR, id: job.id });
    }
  };
};

jobPricingGridActions.refreshSlottedSubRows = (
  benchmarkYear,
  displayIn,
  masterAccountId,
  currency,
  surveysForSlottedMatches,
  slottedJobs,
  getSurveysForSlotted,
  slottedExpandedSections,
  viewName
) => {
  return async dispatch => {
    if (surveysForSlottedMatches && slottedJobs.data?.length > 0) {
      let jobIdIndex;
      let jobCodeIndex;
      let jobCodeKeyIndex;

      slottedJobs.terms.forEach(term => {
        if (term.term === GG_DEFAULTS.ORG_JOB_ID) jobIdIndex = term.id;
        if (term.term === GG_DEFAULTS.ORG_JOB_CODE) jobCodeIndex = term.id;
        if (term.term === GG_DEFAULTS.ORG_JOB_CODE_KEY) jobCodeKeyIndex = term.id;
      });

      if (jobIdIndex && jobCodeIndex && jobCodeKeyIndex) {
        for (const [jobIdString, value] of Object.entries(surveysForSlottedMatches)) {
          const jobId = Number(jobIdString);

          if (jobId && value) {
            slottedJobs.data.forEach(data => {
              if (data[jobIdIndex] === jobId) {
                const jobCode = data[jobCodeIndex];
                const jobCodeKey = data[jobCodeKeyIndex];

                getSurveysForSlotted(
                  { id: jobId, code: jobCode, codeKey: jobCodeKey || ' ' },
                  benchmarkYear,
                  displayIn,
                  masterAccountId,
                  currency,
                  slottedExpandedSections[jobId],
                  viewName
                );
              }
            });
          }
        }
      }
    }
  };
};

jobPricingGridActions.toggleAllSubRows = (
  benchmarkYear,
  displayIn,
  masterAccountId,
  currency,
  slottedJobs,
  jobPricingActions,
  slottedJobIds,
  expanded
) => {
  return async dispatch => {
    if (!expanded) {
      // close all slotted sub rows
      slottedJobIds.forEach(jobId => {
        jobPricingActions.toggleSlottedExpandedSection(jobId, false);
      });
    } else {
      // open all slotted sub rows
      if (slottedJobs.surveysForSlottedMatches && slottedJobs.data.length > 0) {
        let jobIdIndex;
        let jobCodeIndex;
        let jobCodeKeyIndex;

        slottedJobs.terms.forEach(term => {
          if (term.term === GG_DEFAULTS.ORG_JOB_ID) jobIdIndex = term.id;
          if (term.term === GG_DEFAULTS.ORG_JOB_CODE) jobCodeIndex = term.id;
          if (term.term === GG_DEFAULTS.ORG_JOB_CODE_KEY) jobCodeKeyIndex = term.id;
        });

        if (jobIdIndex && jobCodeIndex && jobCodeKeyIndex) {
          slottedJobIds.forEach(jobId => {
            slottedJobs.data.forEach(data => {
              if (data[jobIdIndex] === jobId) {
                const jobCode = data[jobCodeIndex];
                const jobCodeKey = data[jobCodeKeyIndex];

                if (slottedJobs.surveysForSlottedMatches[jobId]) {
                  // already have surveys, no needs to fetch again
                  jobPricingActions.toggleSlottedExpandedSection(jobId, true);
                } else {
                  jobPricingActions.getSurveysForSlotted(
                    { id: jobId, code: jobCode, codeKey: jobCodeKey || ' ' },
                    benchmarkYear,
                    displayIn,
                    masterAccountId,
                    currency,
                    true
                  );
                }
              }
            });
          });
        }
      }
    }
  };
};

jobPricingGridActions.toggleSlottedExpandedSection = (id, value) => {
  return async dispatch => {
    dispatch({ type: PRICING_DETAILS_SLOTTED_EXPANDED_TOGGLE, id, value });
  };
};

function extendReducer(state, action) {
  switch (action.type) {
    case PRICING_DETAILS_EDITING_ADJUSTMENT:
      return {
        ...state,
        editingOverallComment: false,
        editingOverallAdjustment: false,
        currentAdjustmentEditMatch: action.currentAdjustmentEditMatch,
        currentCommentEditMatch: null
      };
    case PRICING_DETAILS_EDITING_ADJUSTMENT_CANCEL:
      return {
        ...state,
        currentAdjustmentEditMatch: null
      };
    case PRICING_DETAILS_EDITING_COMMENT:
      return {
        ...state,
        editingOverallComment: false,
        editingOverallAdjustment: false,
        currentAdjustmentEditMatch: null,
        currentCommentEditMatch: action.currentCommentEditMatch
      };
    case PRICING_DETAILS_EDITING_COMMENT_CANCEL:
      return {
        ...state,
        currentCommentEditMatch: null
      };
    case PRICING_DETAILS_EDITING_OVERALL_ADJUSTMENT:
      return {
        ...state,
        editingOverallComment: false,
        editingOverallAdjustment: true,
        currentCommentEditMatch: null,
        currentAdjustmentEditMatch: null
      };
    case PRICING_DETAILS_EDITING_OVERALL_ADJUSTMENT_CANCEL:
      return {
        ...state,
        editingOverallAdjustment: false
      };
    case PRICING_DETAILS_EDITING_OVERALL_COMMENT:
      return {
        ...state,
        editingOverallComment: true,
        editingOverallAdjustment: false,
        currentCommentEditMatch: null,
        currentAdjustmentEditMatch: null
      };
    case PRICING_DETAILS_EDITING_OVERALL_COMMENT_CANCEL:
      return {
        ...state,
        editingOverallComment: false
      };
    case PRICING_DETAILS_EDITING_CANCEL:
      return {
        ...state,
        editingOverallComment: false,
        editingOverallAdjustment: false,
        currentCommentEditMatch: null,
        currentAdjustmentEditMatch: null
      };
    case PRICING_DETAILS_CHECKING_PARTICIPATION:
      return {
        ...state,
        checkingParticipationIDs: state.checkingParticipationIDs.concat(action.matchId)
      };
    case PRICING_DETAILS_UNCHECKING_PARTICIPATION:
      return {
        ...state,
        uncheckingParticipationIDs: state.uncheckingParticipationIDs.concat(action.matchId)
      };
    case PRICING_DETAILS_PARTICIPATION_SUCCESS:
      return {
        ...state,
        checkingParticipationIDs: state.checkingParticipationIDs.filter(id => id !== action.matchId),
        uncheckingParticipationIDs: state.uncheckingParticipationIDs.filter(id => id !== action.matchId)
      };
    case PRICING_DETAILS_PARTICIPATION_ERROR:
      return {
        ...state,
        checkingParticipationIDs: [],
        uncheckingParticipationIDs: []
      };
    case PRICING_DETAILS_RESET:
      return {
        ...newGenericGrid.getInitialState(),
        editingOverallComment: false,
        editingOverallAdjustment: false,
        currentCommentEditMatch: null,
        currentAdjustmentEditMatch: null
      };
    case PRICING_DETAILS_SLOTTED_DETAILS_START:
      const newStartData = state.slottedDetailsLoading;
      newStartData.push(action.id);

      const newStartExpanded = state.slottedExpandedSections;
      newStartExpanded[action.id] = true;

      return {
        ...state,
        slottedDetailsLoading: newStartData,
        slottedExpandedSections: newStartExpanded
      };
    case PRICING_DETAILS_SLOTTED_DETAILS_SUCCESS:
      const newSuccessData = state.slottedDetailsLoading.filter(item => item !== action.id);
      const newMatches = state.surveysForSlottedMatches;
      newMatches[action.id] = action.data?.data?.data;

      const newSuccessExpanded = state.slottedExpandedSections;
      if (newSuccessExpanded[action.id] && action.expanded === false) {
        newSuccessExpanded[action.id] = false;
      }

      return {
        ...state,
        slottedDetailsLoading: newSuccessData,
        surveysForSlottedMatches: newMatches,
        slottedExpandedSections: newSuccessExpanded
      };
    case PRICING_DETAILS_SLOTTED_DETAILS_ERROR:
      const newErrorData = state.slottedDetailsLoading.filter(item => item !== action.id);
      const newErrorMatches = state.surveysForSlottedMatches;
      newErrorMatches[action.id] = undefined;

      return {
        ...state,
        slottedDetailsLoading: newErrorData,
        surveysForSlottedMatches: newErrorMatches
      };
    case PRICING_DETAILS_SLOTTED_EXPANDED_TOGGLE:
      const newExpanded = state.slottedExpandedSections;
      newExpanded[action.id] = action.value;

      return {
        ...state,
        slottedExpandedSections: newExpanded
      };
    case PRICING_DETAILS_SLOTTED_DETAILS_RESET:
      return {
        ...state,
        surveysForSlottedMatches: {},
        slottedDetailsLoading: [],
        slottedExpandedSections: {}
      };
    default:
      return null;
  }
}

const reducer = newGenericGrid.createReducer(extendReducer);

export default reducer;
